const getLanguage = (i18n) => {
    const language = i18n?.resolvedLanguage || i18n?.language;
    if (language) return language;

    try {
        return localStorage.getItem("i18nextLng") || localStorage.getItem("language") || "en";
    } catch {
        return "en";
    }
};

export const formatDateTime = (date, i18n, showSeconds = true, options = {}) => {
    if (!date) return "—";

    const value = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(value.getTime())) return "—";

    return new Intl.DateTimeFormat(getLanguage(i18n), {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        ...(showSeconds && { second: "2-digit" }),
        ...options,
    }).format(value);
};
